// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA11Majm2b3cf_CaTm6_osEkQyUTR8oBDs",
  authDomain: "effess-brand.firebaseapp.com",
  projectId: "effess-brand",
  storageBucket: "effess-brand.appspot.com",
  messagingSenderId: "348021180500",
  appId: "1:348021180500:web:f9cc6ebbcc5ea9d15645c1",
  measurementId: "G-WW0N1DTX60"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export the initialized app and services
const db = getFirestore();
export { app, db, analytics }; 